<template>
    <div v-html="value"/>
</template>
<script>
export default {
    name : 'stringDisplay',
    props : {
        value : {
            required : true,
        }
    },
};
</script>
